import InsertInvitationIcon from "@mui/icons-material/InsertInvitation";
import { DatePicker } from "@mui/x-date-pickers";

import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";

import dayjs from "dayjs";
import { getFormattedDate } from "utils/date";

const RPMBillingForm = (props) => {
  const {
    accounts,
    formikProps: { touched, errors, setFieldValue } = {},
    payload,
    onInputChange,
  } = props;

  return (
    <div>
      <div style={{ marginBottom: "20px", marginTop: "20px" }}>
        <FormControl
          style={{ width: "100%" }}
          variant="outlined"
          error={touched.account && Boolean(errors.account)}
        >
          <InputLabel id="issue-label">Select Account</InputLabel>
          <Select
            id="accounts"
            labelId="issue-label"
            value={accounts?.length > 1 ? payload.account : accounts?.[0]?.name}
            onChange={(e) => {
              const value = e.target.value;
              onInputChange("account", value);
              setFieldValue("account", value);
            }}
            disabled={accounts?.length === 1}
            label="Select Account"
          >
            {accounts?.map(({ name }, index) => (
              <MenuItem key={index} value={name}>
                {name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {touched.account && errors.account && (
          <FormHelperText error>{errors.account}</FormHelperText>
        )}
      </div>
      <div>
        <FormControl fullWidth>
          <DatePicker
            margin="none"
            fullWidth
            inputVariant="outlined"
            id="billing_date"
            label="Billing Date"
            // className="view-pdf__input"
            views={["month", "year"]}
            value={payload?.billingDate ? dayjs(payload?.billingDate) : null}
            focused={false}
            InputProps={{
              endAdornment: (
                <InsertInvitationIcon style={{ marginRight: "10px" }} />
              ),
            }}
            autoOk
            minDate={dayjs("2023-10-01")}
            maxDate={dayjs(
              new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)
            )}
            onChange={(date) => {
              const formattedDate = getFormattedDate(date, "MMMM YYYY");
              setFieldValue("billingDate", formattedDate);
              onInputChange("billingDate", formattedDate);
            }}
            slotProps={{
              textField: {
                fullWidth: true,
                error: touched.billingDate && Boolean(errors.billingDate),
                helperText: touched.billingDate && errors.billingDate,
              },
            }}
          />
        </FormControl>
      </div>
    </div>
  );
};

export default RPMBillingForm;
